<template>
  <v-form ref="userForm" lazy-validation>
  <v-container class="pt-0 mt-0">
    <v-row>
      <v-spacer />
      <v-col cols="12" md="11">
        <v-card>
          <v-card-title style="word-break: break-word"> Contact the European Palm Society using the form below
          </v-card-title>
          <v-img :src="require('../assets/photos/backgrounds/SAM_0042.jpg')" height="200px"></v-img>
          <v-card-subtitle>
            <v-row>
              <v-text-field clearable outlined shaped persistent-hint label="Name" v-model="messageSenderName"
                counter="200">
              </v-text-field>
            </v-row>
            <v-row>
              <v-text-field clearable outlined shaped :rules="[(value) => !!value || 'Required']" persistent-hint
                label="Email *" v-model="messageSenderEmail" counter="200">
              </v-text-field>
            </v-row>
            <v-row>
              <v-text-field clearable outlined shaped persistent-hint label="Subject" v-model="messageSubject"
                counter="200">
              </v-text-field>
            </v-row>
            <v-row>
              <v-textarea clearable outlined shaped rows="5" auto-grow persistent-hint label="Message"
                v-model="messageBody" counter="200">
              </v-textarea>
            </v-row>
            <v-row>
              <v-alert :type="statusMessageType" dismissible close-text="Close Alert" width="100%" border="left" dense
                :value="showResult" @input="showResult = false"> {{
                  requestResultMessage
                }}</v-alert>
            </v-row>
            <v-row>
              <v-btn class="ma-2 teal eps_white" outlined :loading="messageSending" @click="submitMessage">Send
                Message</v-btn>
            </v-row>
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
  </v-form>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";

export default {
  name: "Contact",
  data: () => ({
    rawFile: null,
    messageSenderName: null,
    messageSenderEmail: null,
    messageSubject: null,
    messageBody: null,
    showResult: false,
    requestResultMessage: null,
    messageSending: false,
    statusMessageType: "success",
    testValue: "nope"
  }),
  mounted() {
    this.$refs.userForm.validate()
  },
  computed: {
    emailAddressIsValid() {
      
      const emailRegex =
        new RegExp(/^[A-Za-z0-9_!#$%&'*+/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");

      let emailExists = (this.messageSenderEmail != null)
      let emailLengthGood = (this.messageSenderEmail.length > 0)
      let emailValid = (emailRegex.test(this.messageSenderEmail))

      let result = emailExists && emailLengthGood && emailValid

      return result; 

    }
  },
  methods: {
    async submitMessage() {

      let empty = "Not Supplied";
      let senderName = (this.messageSenderName) ? this.messageSenderName : empty;
      let senderEmail = (this.messageSenderEmail) ? this.messageSenderEmail : empty;
      let senderSubject = (this.messageSubject) ? this.messageSubject : empty;
      let senderMessage = (this.messageBody) ? this.messageBody : empty;

      if (senderEmail == empty) {
        this.requestResultMessage = "Please provide an email address so we can reply to you";
        this.statusMessageType = "error";
        this.showResult = true;
        return;
      }

      if (!this.emailAddressIsValid) {
        this.requestResultMessage = "Please provide a valid email address";
        this.statusMessageType = "error";
        this.showResult = true;
        return;
      }

      let contactForumModeratorsRequest = serverFunctions.getContactModeratorsRequest(
        senderName,
        senderEmail,
        senderSubject,
        senderMessage
      );

      this.messageSending = true;

      await serverFunctions.getRawPostResponse(
        "/contactForumModerators",
        contactForumModeratorsRequest
      );

      this.messageSending = false;

      this.requestResultMessage = "Message sent, thank you for contacing palmsociety.org.uk";
      this.statusMessageType = "success";
      this.showResult = true;
    }
  },
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}
</style>
